export default __webpack_public_path__ + "static/5-53af8572108d9b1c5834e5c2d9f61499.jpeg";